export interface MtuSliderState {
  currentValue: number;
  dragClientX: number;
  isDragging: boolean;
  disableContinue: boolean;
  enterpriseCapStart: number;
  enterpriseCapEnd: number;
  growthCapStart: number;
  growthCapEnd: number;
  isFaqModalOpen: boolean;
  growthPriceStart: number;
  enterprisePriceStart: number;
}

export enum SliderNotchSize {
  SMALL = `small`,
  LARGE = `large`,
}

export const HARDCODED_TICK_WIDTH_LIMIT = 200000000; // this is specific for the 2023 experiment
